import { useState, useEffect } from 'react';

import LoadingContainer from 'src/componentes/loading-container';
import http from 'src/services/httpService';
import Grafico from 'src/paginas/item/valor/componentes/grafico';

function GraficoMovimentacaoFinanceira({ convenioId, contratoId, projetoId }) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  const getData = async () => {
    setIsLoading(true);

    try {
      const response = await http.post('/MovimentacaoFinanceira/ObterGrafico', {
        convenioId: convenioId,
        contratoId: contratoId,
        projetoId: projetoId,
      });
      setData(response.data || {});
    } catch (_) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (convenioId || contratoId || projetoId) {
      getData();
    }
  }, []);

  const renderContent = () => {
    if (!data) return '';
    return <Grafico grafico={data.grafico} height={350} />;
  };

  return (
    <>
      <LoadingContainer isLoading={isLoading}>
        <div>{data && renderContent()}</div>
      </LoadingContainer>
    </>
  );
}

export default GraficoMovimentacaoFinanceira;
